import { jsx as _jsx } from "preact/jsx-runtime";
import clsx from 'clsx';
import styles from './Background.module.scss';
const Background = ({ isDark = false, centerItems, backgroundColor, children }) => {
    const style = {
        '--pf-background-color': backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : 'none',
    };
    const classNames = clsx(styles.background, {
        [styles.isDark]: isDark,
        [styles.centeredItems]: centerItems,
    });
    return (_jsx("div", Object.assign({ className: classNames, style: !!backgroundColor && style }, { children: children }), void 0));
};
export default Background;
